import React, { useContext, useEffect, useState } from 'react';
import Footer from './../Footer';
import axios from 'axios';
import { site_url, site_url_img } from "./../config.js";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link } from "react-router-dom";
import { AuthContext } from './../AuthContext';
import { parseStoredAccessToken } from '../parseStoredAccessToken.js';
import { FormatDate } from '../Function';
import { FaSearch, FaAngleDoubleRight, FaArrowLeft, FaHeart, FaAngleRight, FaMapMarkerAlt, FaHome, FaList } from "react-icons/fa";

import { Container, Row, Col, Button, Form, Card, Carousel, Navbar, Nav } from "react-bootstrap";

import { useLocation } from 'react-router-dom';

function Index({ children }) {
  const location = useLocation();
  const billFromState = location.state?.shop;
  const { user, fulluser } = useContext(AuthContext);

  const [bill, setBill] = useState(billFromState || null);
  const [loading, setLoading] = useState(!billFromState);
  const [UserActivity, setUserActivity] = useState([]);

  const goBack = () => {
    window.history.back(); // Goes back to the previous page
  };

  // Fetch bill details if not in location.state or if remarks field is missing
  useEffect(() => {
    const fetchBillDetails = async () => {
      // If we have bill from state, try to fetch latest data from API to get remarks
      if (billFromState && billFromState.id) {
        const token = parseStoredAccessToken(user);
        if (token) {
          try {
            // Fetch from customer/instance API to get latest data including remarks
            const res = await axios.get(site_url + "/customer/instance", {
              headers: {
                Authorization: `Bearer ${token}`,
                Accept: 'application/json'
              }
            });

            if (res.data.status === 'success' && res.data.data) {
              // Find the matching bill by ID
              const foundBill = res.data.data.find(b => b.id === billFromState.id);
              if (foundBill) {
                // Merge with original bill data to preserve all fields
                setBill({ ...billFromState, ...foundBill });
                setLoading(false);
                return;
              }
            }
          } catch (err) {
            console.error("Error fetching bill details:", err);
          }
        }
      }
      // If no bill from state, keep loading state
      if (billFromState) {
        setBill(billFromState);
      }
      setLoading(false);
    };

    if (billFromState) {
      // Always try to fetch latest data to ensure remarks are included
      fetchBillDetails();
    } else {
      setLoading(false);
    }
  }, [billFromState, user]);

  if (loading) {
    return (
      <div>
        <Navbar expand="lg" className="navbar px-3">
          <Navbar.Brand className="fw-bold text-white">
            <center>
              <FaArrowLeft onClick={goBack} className="fs-5 text-white notificaton-icon" /> Loading...
            </center>
          </Navbar.Brand>
        </Navbar>
        <div className="transactions p-3" style={{ marginBottom: '30%' }}>
          <center><p>Loading bill details...</p></center>
        </div>
      </div>
    );
  }

  const formatAmount = (value) => {
    const amount = parseFloat(value);
    return Number.isFinite(amount) ? `${amount.toFixed(2)}` : '0.00';
  };

  const billTotal = parseFloat(bill?.totalbillamount)
    || ((parseFloat(bill?.billamount) || 0) + (parseFloat(bill?.tax) || 0));
  const rewardUsed = parseFloat(bill?.customer_reward_used || bill?.reward_points_used || 0) || 0;
  const balancePaid = Math.max(0, billTotal - rewardUsed);

  if (!bill) {
    return (
      <div>
        <Navbar expand="lg" className="navbar px-3">
          <Navbar.Brand className="fw-bold text-white">
            <center>
              <FaArrowLeft onClick={goBack} className="fs-5 text-white notificaton-icon" /> Bill Not Found
            </center>
          </Navbar.Brand>
        </Navbar>
        <div className="transactions p-3" style={{ marginBottom: '30%' }}>
          <center><p>Bill details not available.</p></center>
        </div>
      </div>
    );
  }

  return (
    <div>
      <Navbar expand="lg" className="navbar px-3">

        <Navbar.Brand className="fw-bold text-white"><center><FaArrowLeft onClick={goBack} className="fs-5 text-white notificaton-icon" /> Bill : #{bill.id}</center></Navbar.Brand>
        <Nav className="ms-auto d-flex align-items-center">
        </Nav>
      </Navbar>

      <div className="transactions p-3" style={{ marginBottom: '30%' }}>
        <table class="table table-bordered">
          <thead>
            <tr>
              <th scope="col">Order No</th>
              <th scope="col">#{bill?.id}</th>
            </tr>
            <tr>
              <th scope="col" style={{ color: 'red', fontWeight: 'bold' }}>Token Number</th>
              <th scope="col" style={{ color: 'red', fontWeight: 'bold', fontSize: '1.2rem' }}>{bill?.token_no}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th scope="row">Bill Date</th>
              <td>{FormatDate(bill?.date_time || bill?.created_at)}</td>

            </tr>
            <tr>
              <th scope="row">Bill Amount</th>
              <td>₹{bill?.billamount}</td>

            </tr>
            <tr>
              <th scope="row">Bill Tax</th>
              <td>{bill?.tax}</td>

            </tr>
            <tr>
              <th scope="row">Bill No</th>
              <td>{bill?.billno}</td>

            </tr>
            <tr>
              <th scope="row">Reward Points Received</th>
              <td>{bill?.paytype && String(bill.paytype).includes("Recharge") ? `Instant bonus 🪙${(bill?.commission_amount || 0).toFixed(2)}` : bill?.commission_amount}</td>

            </tr>
            <tr>
              <th scope="row">Shop Name </th>
              <td colspan="2">{bill?.shop_name} - {bill?.phone}</td>

            </tr>
            {bill?.remarks && bill?.remarks.trim() !== '' && (
              <tr style={{ background: '#f8f9fa' }}>
                <th scope="row" style={{
                  verticalAlign: 'top',
                  padding: '15px 12px',
                  color: '#495057',
                  fontWeight: '600'
                }}>
                  Customer Remarks
                </th>
                <td colspan="2" style={{
                  padding: '15px 12px',
                  color: '#212529',
                  lineHeight: '1.6',
                  whiteSpace: 'pre-wrap',
                  wordBreak: 'break-word'
                }}>
                  <div style={{
                    background: '#fff',
                    border: '1px solid #dee2e6',
                    borderRadius: '8px',
                    padding: '12px',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                  }}>
                    <span style={{
                      fontSize: '14px',
                      display: 'block'
                    }}>
                      {bill?.remarks}
                    </span>
                  </div>
                </td>
              </tr>
            )}
            <tr>
              <th scope="row">Reward Points Used (Redeemed)</th>
              <td>🪙{formatAmount(rewardUsed)}</td>
            </tr>
            <tr>
              <th scope="row">Balance Amount Paid By You</th>
              <td>🪙{formatAmount(balancePaid)}</td>
            </tr>
          </tbody>
        </table>

      </div>
    </div>
  )
}

export default Index